import { render, staticRenderFns } from "./HomeAppointment.vue?vue&type=template&id=33785f75"
import script from "./HomeAppointment.vue?vue&type=script&lang=js"
export * from "./HomeAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports